var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"typography",class:[
    ( _obj = {}, _obj[("is-var-" + _vm.variant)] = _vm.variant, _obj['is-uppercase'] =  _vm.uppercase, _obj['is-pre'] =  _vm.pre, _obj ) ]},[_vm._t("default",function(){return [(_vm.pre)?_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}):[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }